import { useEffect, useState } from "react";

enum MediaNetworkProperties {
  "media.name" = "매체",
  DATE = "날짜",
  SUCCESS = "성공 횟수",
  FAIL = "실패 횟수",
  ERROR_COUNT = "고장 횟수",
  ERROR_COUNT_10 = "10분 이상 고장 횟수",
  MAX_ERROR_TIME = "최대 고장 시간",
}

const useMediaNetworkList = (initialPage: number) => {
  const transformData = (
    rawData: any[]
  ): Record<MediaNetworkProperties, any>[] => {
    return rawData.map((item) => ({
      [MediaNetworkProperties["media.name"]]: item.media?.name,
      [MediaNetworkProperties.DATE]: item.date,
      [MediaNetworkProperties.SUCCESS]: item.success,
      [MediaNetworkProperties.FAIL]: item.fail,
      [MediaNetworkProperties.ERROR_COUNT]: item.errorCount,
      [MediaNetworkProperties.ERROR_COUNT_10]: item.errorCount10,
      [MediaNetworkProperties.MAX_ERROR_TIME]: item.maxErrorTime,
    }));
  };

  const [isFetchingComplete, setIsFetchingComplete] = useState(false);

  const [currentPage, setCurrentPage] = useState(initialPage);
  const [data, setData] = useState<any[]>([]);
  const [count, setCount] = useState<number>();
  const [loading, setLoading] = useState(true);

  const [columns, setColumns] = useState<string[]>([]);
  const [tableData, setTableData] = useState<any[]>([]);

  const handleDeleteClick = (mediaNetworkId: string) => {
    const result = window.confirm("삭제하시겠습니까?");
    if (result) {
      fetch(`${process.env.REACT_APP_URL}/media-network/delete`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ mediaNetworkId: mediaNetworkId }),
      })
        .then((response) => {
          if (response.ok) {
            window.location.reload();
          } else {
            alert("삭제에 실패하였습니다.");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          alert("삭제에 실패하였습니다.");
        });
    }
  };

  const fetchData = async (page: any) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_URL}/media-network/list?page=${page}`
      );

      const jsonData = await response.json();
      const transformedData = transformData(jsonData.data.list || []);
      //원본 전체 데이터 보여지는데이터는 tableData로 관리
      setData((prevData) => [...prevData, ...transformedData]);

      if (columns.length === 0 && transformedData.length > 0) {
        const newColumns = Object.keys(transformedData[0]);
        setColumns(newColumns);
      }

      const countResponse = await fetch(
        `${process.env.REACT_APP_URL}/media-network/list`
      );

      if (!countResponse.ok) {
        throw new Error("Network request failed");
      }

      const countJsonData = await countResponse.json();

      const totalDataCount = countJsonData.data.count;
      setCount(totalDataCount);
      // 모든 데이터를 가져온 경우 fetch 종료
      if (
        transformedData.length === 0 ||
        totalDataCount <= data.length + transformedData.length
      ) {
        setIsFetchingComplete(true);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const nextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  return {
    data,
    loading,
    currentPage,
    nextPage,
    count,
    columns,
    tableData,
    setTableData,
    handleDeleteClick,
    isFetchingComplete,
  };
};

export default useMediaNetworkList;
